import PropTypes from 'prop-types';
import { useEffect } from 'react';

import { analytics, getExploreMapSidebarOpen } from '@/utils/analytics';

import Icon from '@/atoms/Icon/Icon';
import Text from '@/atoms/Text/Text';

export default function ExploreStationSidebar({
  categories,
  isMobile,
  isOpen,
  onStationClick,
  setSidebarOpen,
  sidebarOpen,
  title,
}) {
  const toggleSidebar = () => setSidebarOpen((isOpen) => !isOpen);

  useEffect(() => {
    if (isOpen) {
      analytics({
        window,
        document,
        detail: getExploreMapSidebarOpen(null, { linkText: title }),
      });
    }
  }, [isOpen]);

  return (
    <div
      className={`aaco-explore-station w-full md:w-[27vw] md:max-w-[390px] flex flex-col self-start z-30 pl-8 bg-white text-acacia md:transition-[height] md:duration-300 md:ease-out ${
        isOpen ? 'mt-[55vh] md:mt-0 md:h-full' : 'h-fit md:h-[93px]'
      } ${isMobile && !isOpen && 'absolute bottom-0'} ${
        sidebarOpen ? 'hidden md:flex' : ''
      }`}
    >
      <div
        className="aaco-explore-station__header border-b-1 border-black flex justify-between md:mt-[15px] items-center mr-6 py-4"
        onClick={toggleSidebar}
        role="button"
      >
        <Text style="text-black " tag="body">
          {title}
        </Text>
        <Icon
          className={`text-black mb-1 transition-transform duration-500 ${
            isOpen && 'rotate-180'
          }`}
          height={12}
          name="chevron-down"
          width={12}
        />
      </div>
      <div
        className={`aaco-explore-station__content pr-8 pt-2 md:pt-6 flex flex-col gap-y-[42px] h-max overflow-y-auto ${
          isOpen ? '' : 'hidden'
        }`}
      >
        {categories?.length > 0 &&
          categories?.map((category) => {
            return (
              <div
                className="aaco-explore-station__content__category"
                key={category?.id}
              >
                <div className="aaco-explore-station__content__category__header md:mt-[12px]">
                  <Text style="text-black" tag="caption">
                    {category?.name}
                  </Text>
                </div>
                <div className="aaco-explore-station__content__category__content">
                  {category?.stations?.detail?.length > 0 &&
                    category.stations.detail.map((station, stationIdx) => {
                      return (
                        <div
                          className="aaco-explore-station__content__category__content__item py-5 flex justify-between items-center border-b border-b-black"
                          key={station?.id}
                          onClick={() =>
                            onStationClick({
                              categoryIdx: category.stations.categoryIdx,
                              detail: station,
                              stationIdx,
                            })
                          }
                          role="button"
                        >
                          <Text style="text-black uppercase" tag="body">{station?.name}</Text>
                          <div>
                            <Icon
                              className="text-black"
                              height={12}
                              name="chevron-down"
                              width={12}
                            />
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}

ExploreStationSidebar.propTypes = {
  categories: PropTypes.array,
  isMobile: PropTypes.bool,
  onStationClick: PropTypes.func,
  title: PropTypes.string,
};
